import { Component } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';

@Component({
  selector: 'app-payment-info-modal',
  standalone: false,
  templateUrl: './payment-info-modal.component.html',
  styleUrl: './payment-info-modal.component.css'
})
export class PaymentInfoModalComponent {
  paymentInfo: any[] = []

  constructor(public modalRef: MdbModalRef<PaymentInfoModalComponent>) { }

  toLocalFormat(dateStr: string): string {
    const date = new Date(dateStr);
    return `${date.toLocaleDateString('es-CL')} ${date.toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' })}`;
  }

}
